<template>
  <span>
    <span
      v-if="parsedHours != 0"
    >
      {{ parsedHours }} hour{{ hoursSuffix }}
    </span>
    <span
      v-if="parsedMinutes != 0"
    >
      {{ parsedMinutes }} minute{{ minutesSuffix }}
    </span>
  </span>
</template>

<script>
export default {
  name: 'MinutesToHours',
  props: {
    minutes: {
      type: Number,
      default: () => 0,
    },
  },
  computed: {
    parsedMinutes() {
      return this.minutes % 60;
    },
    minutesSuffix() {
      return this.parsedMinutes === 1 ? '' : 's';
    },
    parsedHours() {
      return Math.floor(this.minutes / 60);
    },
    hoursSuffix() {
      return this.parsedHours === 1 ? '' : 's';
    },
  },
};
</script>
